import React,{useState} from 'react'
import { Form, Button } from 'antd';
import { AuthWrapper } from '../../style';
import Heading from '../../../../../../components/heading/heading';
import { useDispatch, useSelector } from 'react-redux';
import ReactGA from 'react-ga';
import classNames from 'classnames';
import './ErrorPopup.css'
import { submitMetadata } from '../../../../../../redux/authentication/actionCreator';

function ErrorPopup() {
    const dispatch = useDispatch()
    
    const revertBack = () =>{
        dispatch({type:'RESET_DATA'})
        window.location.href = "/"
    }
    return (
    <AuthWrapper>
      <div className="auth-contents">
        <Form layout="vertical">
            <Heading as="h5">
                Mohon maaf
            </Heading>
            <p>Kami tidak dapat menerima permohonan anda sebagai <br/>Rakan Kongsi Klub buat masa sekarang kerana 
            <br/>profil anda tidak mematuhi garis panduan kami.</p>
            <p>Untuk pengetahuan lebih lanjut, emel kami di <br/><a href="mailto:kongsiklub@aspirasi.co"><b>kongsiklub@aspirasi.co</b></a> .</p>
            <Button className="btn-create" type="primary" size="large" onClick={revertBack}>
               KEMBALI KE LAMAN UTAMA
            </Button>
        </Form>
      </div>
    </AuthWrapper>
    )
}

export default ErrorPopup
